var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { MainContent } from "../../MainContent";
var RenderMainHeading = /** @class */ (function (_super) {
    __extends(RenderMainHeading, _super);
    function RenderMainHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderMainHeading.prototype.render = function () {
        var name = (this.props.cms.ShowLivePhraseBeforeSportName ? this.props.dict.Live : "") + " " + this.props.name + " " + (this.props.subName || "");
        var eventsCount = this.props.cms.ShowSportEventsCount ? "(" + this.props.eventsCountLength + ")" : "";
        var shouldExpand = this.props.renderedHeadings < this.props.cms.ExpandedMainGroupItems;
        var props = __assign({}, this.props, { name: name, eventsCount: eventsCount, shouldExpand: shouldExpand });
        return (React.createElement(MainContent, __assign({ key: "sport-content-" + this.props.id }, props), this.props.children));
    };
    return RenderMainHeading;
}(React.PureComponent));
export { RenderMainHeading };
//# sourceMappingURL=RenderMainHeading.js.map